export default "__VITE_ASSET__CUhWDylN__"